import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AlmacenService} from "../../services/api/almacen.service";
import {MatTableDataSource} from "@angular/material/table";
import Swal from "sweetalert2";
import {DialogInventarioAventuraComponent} from "./dialog-inventario-aventura/dialog-inventario-aventura.component";
import {LoadingService} from "../../services/interceptors/loading.service";
import { AventuraService } from 'src/app/services/api/aventura.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-inventario',
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.css']
})
export class InventarioComponent implements OnInit {

  articulos: any = [];
  equipo: any

  displayedColumns: string[] = [
    'codigo',
    'estado',
    'nombre',
    'marca',
    'modelo',
    'talla',
    'categoria',
    //'estado',
    'valoracion',
    'costo',
    'observaciones',
    'proveedor',
    'ruc',
    'numFactura',
    'modificar',
    'eliminar'
  ];

  dataSource: any;
  loading: boolean = true;

  selectNombre: string | null = null;
  selectMarca: string | null = null;
  selectModelo: string | null = null;
  selectTalla: string | null = null;
  selectCategoria: string | null = null;
  selectEstado: string | null = null;

  arrayNombres: any = [];
  arrayMarcas: any = [];
  arrayModelos: any = [];
  arrayTallas: any = [];
  arrayCategorias: any = [];
  arrayEstados: any = ['AVERIADO','DISPONIBLE','NO RETORNADO'];


  // @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
  //   this.dataSource.paginator = value;
  // }


  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private cdr: ChangeDetectorRef,public dialog: MatDialog, private almacenService: AventuraService) {
  }

  ngOnInit() {
    this.getAllEquipos();

  }

  getAllEquipos() {
    this.almacenService.getAllEquiposInventario().subscribe((response) => {
      this.articulos = response.getAllEquiposInventario;

      this.articulos = this.articulos.sort((a: any, b: any) => {

        if (!a.codigo) return 1;
        if (!b.codigo) return -1

        // Separar el código en dos partes: prefijo y número
        const [prefijoA, numeroA] = a.codigo.split('-');
        const [prefijoB, numeroB] = b.codigo.split('-');
  
        // Ordenar alfabéticamente por el prefijo
        const prefijoComparacion = prefijoA.localeCompare(prefijoB);
  
        // Si los prefijos son iguales, ordenar por el número
        if (prefijoComparacion === 0) {
          return parseInt(numeroA, 10) - parseInt(numeroB, 10);
        }
  
        return prefijoComparacion;
      });
      
      const nombre = this.articulos.filter((item: any) => item.nombreEquipo !== '' && item.nombreEquipo !== null).map((item: any) => (item.nombreEquipo))
      const marca = this.articulos.filter((item: any) => item.marcaEquipo !== '' && item.marcaEquipo !== null).map((item: any) => (item.marcaEquipo))
      const modelo = this.articulos.filter((item: any) => item.modeloEquipo !== '' && item.modeloEquipo !== null).map((item: any) => (item.modeloEquipo))
      const talla = this.articulos.filter((item: any) => item.tallaEquipo !== '' && item.tallaEquipo !== null).map((item: any) => (item.tallaEquipo))
      const categoria = this.articulos.filter((item: any) => item.categoria !== '' && item.categoria !== null).map((item: any) => (item.categoria))
      const estado = this.articulos.filter((item: any) => item.estado !== '' && item.estado !== null).map((item: any) => (item.estado))

      this.arrayNombres = [...new Set(nombre)]
      this.arrayMarcas = [...new Set(marca)]
      this.arrayModelos = [...new Set(modelo)]
      this.arrayTallas = [...new Set(talla)]
      this.arrayCategorias = [...new Set(categoria)]

      console.log(this.articulos)
      this.dataSource = new MatTableDataSource(this.articulos);
      this.cdr.detectChanges();
      this.dataSource.paginator = this.paginator
      this.loading=false
      return response;
    });

  }

  getTooltipText(element: any): string {
    if (element.estado === 'NO RETORNADO') {
      return `NO RETORNADO - FILE ${element.fileAsignado || 'N/A'}`;
    }
    return '';
  }

  getEquipoById(id:any) {
    this.almacenService.getEquipoInventario(id).subscribe((response) => {
      this.equipo = response.getEquipoInventario;
      return this.equipo;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  openDialogModify(i: any): void {

    let dialogConfig = new MatDialogConfig();
    console.log(i)
    this.almacenService.getEquipoInventario(i).subscribe((response) => {
      this.equipo = response.getEquipoInventario;

      console.log(this.equipo)
      dialogConfig.data = {
        id:this.equipo.id,
        nombre: this.equipo.nombreEquipo,
        marca: this.equipo.marcaEquipo,
        modelo: this.equipo.modeloEquipo,
        talla: this.equipo.tallaEquipo,
        categoria: this.equipo.categoria,
        valoracion: this.equipo.valoracionEquipo,
        costo: this.equipo.costo,
        observaciones: this.equipo.observacionEquipo,
        razonSocial:this.equipo.factura?.razonSocial,
        ruc:this.equipo.factura?.ruc,
        numFactura:this.equipo.factura?.numFactura,
        title: "Modificar Equipo",
        estado:1
      };
      dialogConfig.width = "40rem";
      dialogConfig.height="500px";

      let dialogRef = this.dialog.open(DialogInventarioAventuraComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        console.log("closed");
        console.log(result);
        if(result==1){
          this.getAllEquipos();
        }
      });
    });


  }

  openDialogAdd(): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      nombre:"",
      marca:"",
      modelo:"",
      categoria:"",
      valoracion:"",
      observaciones:"",
      talla:"",
      costo:"",
      razonSocial:"",
      ruc:"",
      numFactura:"",
      title:"Agregar Equipo",
      estado:2
    };
    dialogConfig.width="40rem";
    dialogConfig.height="500px";

    let dialogRef = this.dialog.open(DialogInventarioAventuraComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log("closed");
      console.log(result);
      if(result==1){
        this.getAllEquipos();
      }
    });
  }


  deleteEquipo(equipoId: any,i:number): void {

    Swal.fire({
      title: 'Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.almacenService.deleteEquipoInventario(equipoId).subscribe((data: any)=>{
          console.log(data);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'El registro se eliminó satisfactoriamente.',
            showConfirmButton: false,
            timer: 4000
          });
/*           this.dataSource.data.splice(i, 1);
          this.dataSource._updateChangeSubscription(); */
          this.getAllEquipos()
        })

      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("false");
      }
    })

  }

  
  onSelectionChangedEquipo(event: MatSelectChange) {
    const selectedNombre = event.value;
    this.arrayMarcas = [...new Set(this.articulos
      .filter((item: any) => item.nombreEquipo === selectedNombre)
      .map((item: any) => item.marcaEquipo))];
    this.selectMarca = null;
    this.arrayModelos = [];
    this.selectModelo = null;
    this.applyFilterSelect();
  }

  onSelectionChangedMarca(event: MatSelectChange) {
    const selectedMarca = event.value;
    this.arrayModelos = [...new Set(this.articulos
      .filter((item: any) => item.marcaEquipo === selectedMarca && item.nombreEquipo === this.selectNombre)
      .map((item: any) => item.modeloEquipo))];
    this.selectModelo = null;
    this.applyFilterSelect();
  }

  applyFilterSelect() {

    let dataNew: any = this.articulos
    if (this.selectNombre) {
      dataNew = dataNew?.filter((item: any) => item.nombreEquipo === this.selectNombre)

    }
    if (this.selectMarca) {
      dataNew = dataNew?.filter((item: any) => item.marcaEquipo === this.selectMarca)

    } if (this.selectModelo) {
      dataNew = dataNew?.filter((item: any) => item.modeloEquipo === this.selectModelo)

    } if (this.selectTalla) {
      dataNew = dataNew?.filter((item: any) => item.tallaEquipo === this.selectTalla)

    } if (this.selectCategoria) {
      dataNew = dataNew?.filter((item: any) => item.categoria === this.selectCategoria)

    } if (this.selectEstado) {
      if (this.selectEstado === 'DISPONIBLE') {
        dataNew = dataNew?.filter((item: any) => item.estado === 'DISPONIBLE' || item.estado === null);
      } else {
        dataNew = dataNew?.filter((item: any) => item.estado === this.selectEstado);
      }
    }
    

    this.dataSource.data = dataNew
  }
}
